'use client';

import { useEffect, useState } from 'react';

export type TailwindScreens = {
  xxs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  '2xl': boolean;
};

const breakpoints = {
  xxs: 450,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export default function useTailwindBreakpoint(): TailwindScreens {
  const [screens, setScreens] = useState<TailwindScreens>({
    xxs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    '2xl': false,
  });

  useEffect(() => {
    const mediaQueries = {
      xxs: window.matchMedia(`(min-width: ${breakpoints.xxs}px)`),
      sm: window.matchMedia(`(min-width: ${breakpoints.sm}px)`),
      md: window.matchMedia(`(min-width: ${breakpoints.md}px)`),
      lg: window.matchMedia(`(min-width: ${breakpoints.lg}px)`),
      xl: window.matchMedia(`(min-width: ${breakpoints.xl}px)`),
      '2xl': window.matchMedia(`(min-width: ${breakpoints['2xl']}px)`),
    };

    const updateScreens = () => {
      setScreens({
        xxs: mediaQueries.xxs.matches,
        sm: mediaQueries.sm.matches,
        md: mediaQueries.md.matches,
        lg: mediaQueries.lg.matches,
        xl: mediaQueries.xl.matches,
        '2xl': mediaQueries['2xl'].matches,
      });
    };

    updateScreens();

    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener('change', updateScreens),
    );

    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener('change', updateScreens),
      );
    };
  }, []);

  return screens;
}
